/**
 * Convert string to number; Imported from: dash-components - utils/formatUtils.ts to prevent circular dependency
 * @param dollars value to convert
 * @returns number
 */
export const convertToNumber = (dollars: string | number | undefined) => {
    if (dollars === undefined) return 0;
    if (typeof dollars === 'number') return dollars;

    const v = dollars.replace(/[^0-9.]/g, '');
    return Number(v);
};

/**
 * Create a blob from a base64 string.
 * @param base64 The base64 string to convert.
 * @param mimeType The MIME type of the resulting blob.
 * @returns A Blob object.
 */
export const getBlobFromBase64 = (base64: string, mimeType = 'application/pdf'): Blob => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
};
